export enum LikelihoodOfCompletion {
  ESTATE_AGENT_TARGET = 'ESTATE_AGENT_TARGET',
  CUSTOMER_TARGET = 'CUSTOMER_TARGET',
  EXCHANGE = 'EXCHANGE',
  NOTICE_TO_COMPLETE = 'NOTICE_TO_COMPLETE',
  SOLICITORS_TARGET = 'SOLICITORS_TARGET',
}

export type Conveyancing = {
  offerSignedAt: Date | null;
  productFeesPaidAt: Date | null;
  offerExpiresAt: Date | null;
  valuationExpiresAt: Date | null;
  undertakingPaidAt: Date | null;
  propertyTitleNumber: string | null;
  contributionStatementApprovedAt: Date | null;
  financeDocsSentForSignatureAt: Date | null;
  financeDocsSignedAt: Date | null;
  targetCompletionAt: Date | null;
  likelihoodOfCompletion: LikelihoodOfCompletion | null;
  finalCompletionPackReceivedAt: Date | null;
  fundsInstructedAtTime: Date | null;
  fundsReleasedAtTime: Date | null;
  completionDate: Date | null;
  startDate: Date | null;
  procFeeRequestedAt: Date | null;
  procFeePaidAt: Date | null;
  fundingPool: string | null;
};
